import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Table,
  PopoverBody,
  Popover
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import Loader from "../../Components/Common/Loader";

const DayOfWeekDiscountPerformance = ({ mealPeriod, leftFilter, discountCodes, serveList, currency, activeTab, setActiveTab, durations }) => {
  // const durations = ["30", "60", "90"];
  // const [activeTab, setActiveTab] = useState(durations[0]);
  const [popup, setPopup] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tempPopupData, setTempPopupData] = useState()
  const [discountserverData, setDiscountServerData] = useState([]);

  const cellRefs = useRef({});
  const wrapperRef = useRef(null); // 👉 new ref to the wrapper that owns positioning

  const dayLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];



  useEffect(() => {
    // if (!hasMore) return;
    const controller = new AbortController();
    setLoading(true);
    postDataAPI({
      serviceName: 'kpi_data',
      op: 'day_of_week_discount_performance',
      leftFilter: leftFilter,
      mealPeriod: mealPeriod,
      server_id: serveList,
      discount_id: discountCodes,
      trend_period: activeTab
    }, controller.signal).then((response) => {
      setLoading(false);
      
      const weekDayCount = {};
      const weekDayCountTrend = {};
      response?.data?.data?.weekdayCounts.forEach(item => {
        weekDayCount[item.weekday] = Number(item.day_count);
      });
      response?.data?.data?.weekdayCountsTrends.forEach(item => {
        weekDayCountTrend[item.weekday] = Number(item.day_count);
      });

      const discountMap = {};
      const totalMap = {};
      const weekdaysOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      // Process each record
      response?.data?.data?.discountData.forEach(({ weekday, discount_name, noTimes, noTimeTrend }) => {

        const value =  parseInt(noTimes / weekDayCount[weekday])
        const trendValue =  parseInt(noTimeTrend / weekDayCountTrend[weekday])

        let trend = 'on trend';

        if (value > trendValue) trend = 'below trend';
        else if (value < trendValue) trend = 'above trend';

        // Initialize if needed
        if (!discountMap[discount_name]) {
          discountMap[discount_name] = {};
        }

        discountMap[discount_name][weekday] = { value, trend, weekday };

        // Prepare TOTAL
        if (!totalMap[weekday]) {
          totalMap[weekday] = { value: 0, trendValue: 0 };
        }

        totalMap[weekday].value +=  value;
        totalMap[weekday].trendValue +=  trendValue;
      });

      // Convert discountMap into final array
      const finalData = [];

      // First: Add TOTAL
      const total = {
        discountType: 'TOTAL',
        data: weekdaysOrder.map((day) => {
          const val = parseInt(totalMap[day]?.value) || 0;
          const trendVal = parseInt(totalMap[day]?.trendValue) || 0;
                   
          let trend = 'on trend';
          if (val > trendVal) trend = 'below trend';
          else if (val < trendVal) trend = 'above trend';
          return { value: val, trend, weekday: day };
        }),
      };

      finalData.push(total);

      // Then: Add all individual discounts
      Object.keys(discountMap).forEach((discountType) => {
        const data = weekdaysOrder.map((day) => {
          const entry = discountMap[discountType][day];
          return entry ? entry : { value: 0, trend: 'on trend' };
        });
        // Check if all values are 0
        const isAllZero = data.every(item => item.value === 0);
        if (!isAllZero) {
          finalData.push({ discountType, data });
        }
      });

      setDiscountServerData(finalData);

    });
    return () => {
        controller.abort();
    };
  }, [mealPeriod, leftFilter, discountCodes, serveList, activeTab]);

  const handleGetPopUpData = (rowIdx, colIdx, discount_name, cell) => {
    setTempPopupData({ discount_name: discount_name, weekday: cell?.weekday })
    if (popup && tempPopupData?.discount_name === discount_name && tempPopupData?.weekday === cell?.weekday) {
      return;
    }
    console.log("CELL");
    
    console.log(cell); 
    postDataAPI({
      serviceName: 'kpi_data',
      op: 'dow_discount_performance_detail',
      leftFilter: leftFilter,
      mealPeriod: mealPeriod,
      server_id: serveList,
      discount_id: discountCodes,
      discount_type: discount_name === "TOTAL" ? "total" : "discount_name",
      discount_name: discount_name,
      weekday: cell?.weekday,
      trend_period: activeTab
    }).then((response) => {
      if (response?.status === "ok") {
        const weekDayCount = {};
        Object.entries(response?.data?.data?.weekdayCounts).forEach(([key, value]) => {
          weekDayCount[key] = value; // or result[Number(key)] = value;
        });

        setPopup((prev) =>
          prev && prev.row === rowIdx && prev.col === colIdx
            ? null
            : {
              row: rowIdx,
              col: colIdx,
              discountType: discount_name,
              weekday: cell?.weekday,
              trend: cell?.trend,
              value: cell?.value,
              avgTrendData: response?.data?.data?.trend,
              historical: response?.data?.data?.historical,
              weekDayCount: weekDayCount
            }
        );
      } else {
        console.log("error");

      }

    });
  }

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setPopup(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isMobile = window.innerWidth <= 576;
  const isTablet = window.innerWidth <= 1024;

  return (
    <Card>
      <CardHeader className="d-flex flex-wrap justify-content-between">
        {/* Left Title & Subtitle with Icon */}
        <div className="d-flex align-items-start">
          <div className={`icon-box rounded bg-danger text-white`}>
            <i className="ri-calendar-2-fill"></i>
          </div>
          <div className="ps-2">
            <h5 className="mb-1">Day of Week Discount & Promotion Performance (Items)</h5>
            <p className="text-muted mb-0">
              Weekly (promotional) discount patterns with trend analysis
            </p>
          </div>
        </div>
        <div className="d-flex  justify-content-end flex-wrap gap-2 align-items-center">
          <p className="p-1 mb-0">Color coding based on:</p>
          <Nav tabs className="bg-light p-1 navitems">
            {durations.map((d) => (
              <NavItem key={d}>
                <NavLink
                  href="#"
                  onClick={() => setActiveTab(d)}
                  className={`px-3 py-1 me-2 fw-semibold navlinks ${activeTab === d ? "bg-white active" : ""}`}
                >
                  {d} Days
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </div>
      </CardHeader>
      {loading && <Loader />}
      <div className={`p-0 ${loading ? "opacity-0" : ''}`}>
        <CardBody>
          <div className="table-responsive" style={{ maxHeight: "400px", overflowX: 'auto' }} ref={wrapperRef}>
            <Table responsive className="table-bordered table-hover table-nowrap align-middle mb-0 table-sm" style={{ minWidth: '900px' }}>
              <thead className="bg-light">
                <tr style={{ position: "sticky" }}>
                  <th className="w-25">
                    <span className="d-inline-block fs-16 fw-semibold px-3 py-2 text-start">
                      Discount Type
                    </span>
                  </th>
                  {dayLabels.map((d) => (
                    <th key={d} className="text-center">
                      <span className="d-inline-block fs-16 fw-semibold px-3 py-2">{d}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {discountserverData.map((item, rowIdx) => (
                  <tr key={rowIdx} className={rowIdx === 0 ? "bg-info bg-opacity-10" : ""}>
                    <td className="text-start w-25">
                      <span className={`d-inline-block ${rowIdx === 0 ? "fs-18 fw-bold text-danger" : "fs-16 fw-semibold"} px-3 py-2`}>
                        {item.discountType}
                      </span>
                    </td>
                    {item.data.map((cell, colIdx) => {
                      const key = `${rowIdx}-${colIdx}`;
                      const buttonId = `popover-${key}`; // Unique ID for each cell
                      return (
                        <td
                          key={key}
                          className="text-center"
                          ref={(el) => (cellRefs.current[key] = el)}
                          onClick={() => handleGetPopUpData(rowIdx, colIdx, item.discountType, cell)}
                        >
                          <span
                            id={buttonId}
                            style={{ width: '70px' }}
                            className={`d-inline-block px-3 py-2 fw-bold  cursor-pointer ${cell.trend === "below trend"
                              ? "table-data-value-below-trend"
                              : cell.trend === "above trend"
                                ? "table-data-value-above-trend"
                                : "table-data-value-on-trend"
                              }`}
                          >
                            {cell.value ? cell.value : 0}
                          </span>
                          {popup && popup.row === rowIdx && popup.col === colIdx && (
                            <Popover
                              style={{
                                width: isMobile ? "250px" : isTablet ? "290px" : '350px',
                                background: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: 8,
                                padding: isMobile ? "3px" : "6px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                              }}
                              fade={true}
                              isOpen={true}
                              toggle={() => setPopup(null)}
                              target={buttonId}
                            >
                              <PopoverBody>
                                <div>
                                  <div className="d-flex justify-content-between mb-2">
                                    <p className="fs-16 fw-semibold">{popup.discountType}</p>
                                    <p className="d-inline-block align-items-center border rounded-pill px-4 border-1 border-dark" style={{ height: 'fit-content' }}>{popup.weekday}</p>
                                  </div>
                                  <div className={`d-flex justify-content-between align-items-center p-2 bg-opacity-10 rounded-3 border border-0  ${cell.trend === "below trend"
                                    ? "table-data-value-below-trend"
                                    : cell.trend === "above trend"
                                      ? "table-data-value-above-trend"
                                      : "table-data-value-on-trend"
                                    }`}>
                                    <p className="fs-12 text-muted fw-semibold mb-0">{popup.row === 0 ? "Total" : "Current"}</p>
                                    <p className={`fw-semibold ${isMobile ? "fs-18" : 'fs-24'} mb-0 ${popup.trend === "below trend"
                                      ? "text-danger"
                                      : popup.trend === "above trend"
                                        ? "text-success"
                                        : ""
                                      }`}>{popup.value}</p>
                                  </div>
                                  <hr className="my-3" />
                                  {Object.entries(popup?.avgTrendData || {})?.map(([key, value]) => {
                                    const dayCount = popup?.weekDayCount?.[key] || 1; // default to 1 if undefined
                                    const avg = Math.floor(value / dayCount); // rounded down; use Math.round if needed

                                    return (
                                      <div className="d-flex justify-content-between align-items-center" key={key}>
                                        <p className="text-muted fw-semibold mb-2">
                                          {key}-day {popup.row === 0 && 'Total'} Average
                                        </p>

                                        <div className={`d-flex justify-content-between ${isMobile ? 'gap-1' : 'gap-2'}`}>
                                          <p className={`fw-semibold ${isMobile ? "fs-14" : "fs-18"} mb-2`}>
                                            {avg}
                                          </p>

                                          {avg !== 0 && (
                                            popup.value < avg ? (
                                              <i className={`ri-arrow-right-up-line ${isMobile ? 'fs-14' : 'fs-18'} text-danger`}></i>
                                            ) : (
                                              <i className={`d-block ri-arrow-right-down-line ${isMobile ? 'fs-14' : 'fs-18'} text-success`}></i>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}

                                  <hr className="mb-3 mt-0" />

                                  <p className="fs-16 fw-semibold">{popup.row === 0 ? "Total Breakdown" : "Historical Data"}</p>
                                  {Object.entries(popup?.historical)?.map(([key, value]) => (
                                    <div className="d-flex justify-content-between my-0" key={key}>
                                      <p className="text-muted fs-14 mb-2">{key}</p>
                                      <p className="fw-semibold mb-2">{value}</p>
                                    </div>
                                  ))
                                  }
                                </div>
                              </PopoverBody>
                            </Popover>
                          )}

                        </td>
                      );
                    })}

                  </tr>
                ))}

              </tbody>
            </Table>
          </div>

          {/* Legend */}
          <div className="d-flex justify-content-between mt-3 flex-wrap gap-2">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <p className="d-flex align-items-center text-muted">
                <span className="me-2" style={{ width: "15px", height: "15px", borderRadius: "2px", backgroundColor: "#ffe2e3" }}></span>
                Below Trend
              </p>
              <p className="d-flex align-items-center text-muted">
                <span className="me-2" style={{ width: "15px", height: "15px", borderRadius: "2px", backgroundColor: "#dcfce7" }}></span>
                Above Trend
              </p>
              <p className="d-flex align-items-center text-muted">
                <span className="me-2" style={{ width: "15px", height: "15px", borderRadius: "2px", backgroundColor: "#F3F4F6" }}></span>
                At Trend
              </p>
            </div>
            <p className="text-muted mb-0">
              {`Currently showing trends based on ${activeTab}-day average`}
            </p>
          </div>
        </CardBody>
      </div>
    </Card>

  );
};

export default DayOfWeekDiscountPerformance;
